import {
  ACTION_GET_COMPANY,
  ACTION_GET_COMPANY_SUCCESS,
  ACTION_GET_COMPANY_FAILURE,
  ACTION_UPDATE_COMPANY_EMPLOYEES,
  ACTION_EMPTY_COMPANY,
  ACTION_PUT_COMPANY_SUCCESS,
  ACTION_POST_DEPARTMENT_SUCCESS,
  ACTION_DEACTIVATE_COMPANY,
  ACTION_UPDATE_COMPANY_STATUS,
  ACTION_REACTIVATE_COMPANY,
  ACTION_PUT_COMPANY_STATUS_SUCCESS,
  ACTION_PUT_COMPANY_STATUS_FAILURE,
  ACTION_GET_COMPANY_FLAGS,
  ACTION_GET_COMPANY_FLAGS_SUCCESS,
  ACTION_GET_COMPANY_FLAGS_FAILURE,
} from '../configs/ActionTypes';

import { Company } from './types';

import * as _ from 'lodash-es';

const initialState = {
  company: {
    employees: [],
    departments: [],
    creditCards: [],
  },
  flags: null as Record<string, boolean> | null,
  flagsLoading: false,
  isLoading: false,
  success: null,
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case ACTION_GET_COMPANY: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case ACTION_EMPTY_COMPANY: {
      return initialState;
    }

    case ACTION_POST_DEPARTMENT_SUCCESS: {
      const department = action.payload.payload;

      return {
        ...state,
        company: {
          ...state.company,
          departments: [...state.company.departments, department],
        },
      };
    }

    case ACTION_GET_COMPANY_SUCCESS: {
      const p = action.payload.payload;

      const company: Company = {
        id: p.id,
        name: p.name,
        status: p.status,
        legalName: p.legalName ?? '',
        primaryDomain: p.primaryDomain,
        employees: _.get(p, 'employees', []),
        size: _.get(p, 'size', null),
        departments: _.get(p, 'departments', []),
        additionalDomains: _.get(p, 'additionalDomains', []),
        creditCards: _.get(p, 'creditCards', []),
        companyCode: _.get(p, 'companyCode', ''),
        travelPolicies: _.get(p, 'travelPolicies', []),
        expensePolicies: _.get(p, 'expensePolicies', []),
        agency: _.get(p, 'agency', null),
        address: _.get(p, 'address', null),
        notes: _.get(p, 'notes', ''),
      };

      return {
        ...state,
        company: {
          ...state.company,
          ...company,
        },
        isLoading: false,
        success: true,
      };
    }

    case ACTION_UPDATE_COMPANY_EMPLOYEES: {
      const p = action.payload.payload;

      const employees = state.company.employees.map((o: any) =>
        o.id == p.id ? { ...o, status: _.get(p, 'status', '') } : o,
      );

      return {
        ...state,
        company: {
          ...state.company,
          employees,
        },
        isLoading: false,
      };
    }

    case ACTION_PUT_COMPANY_SUCCESS: {
      const p = action.payload.payload;
      let compCode = _.get(p, 'companyCode', '');
      compCode =
        compCode == '' ? _.get(state.company, 'companyCode', '') : compCode;

      const company: Company = {
        id: p.id,
        name: p.name,
        status: p.status,
        legalName: p.legalName,
        primaryDomain: p.primaryDomain,
        additionalDomains: _.get(p, 'additionalDomains', []),
        employees: _.get(state.company, 'employees', undefined),
        size: _.get(p, 'size', null),
        address: _.get(p, 'address', null),
        departments: _.get(state.company, 'departments', undefined),
        creditCards: _.get(state.company, 'creditCards', undefined),
        travelPolicies: _.get(state.company, 'travelPolicies', []),
        expensePolicies: _.get(p, 'expensePolicies', []),
        agency: _.get(p, 'agency', null),
        companyCode: compCode,
        notes: _.get(p, 'notes', ''),
      };

      return {
        ...state,
        company: {
          ...state.company,
          ...company,
        },
      };
    }

    case ACTION_UPDATE_COMPANY_STATUS: {
      const p = action.payload.payload;

      return {
        ...state,
        company: {
          ...state.company,
          status: p.status,
        },
        isLoading: false,
      };
    }

    case ACTION_DEACTIVATE_COMPANY: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case ACTION_PUT_COMPANY_STATUS_SUCCESS: {
      return {
        ...state,
        companyId: action.payload.payload.id,
        isLoading: false,
        success: true,
      };
    }

    case ACTION_PUT_COMPANY_STATUS_FAILURE: {
      return {
        ...state,
        isLoading: false,
        success: false,
      };
    }

    case ACTION_REACTIVATE_COMPANY: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case ACTION_GET_COMPANY_FLAGS: {
      return {
        ...state,
        flagsLoading: true,
      };
    }

    case ACTION_GET_COMPANY_FLAGS_SUCCESS: {
      return {
        ...state,
        flags: { ...action.payload.payload },
        flagsLoading: false,
      };
    }

    case ACTION_GET_COMPANY_FLAGS_FAILURE: {
      return {
        ...state,
        flags: null,
        flagsLoading: false,
      };
    }

    default: {
      return state;
    }
  }
}
